












































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { get, cloneDeep } from 'lodash-es';
import { getResponseToMTH } from '@/utils/helpers';
import constants from '@/utils/constants';

@Component
export default class FeeCalculationSetting extends Vue {
  $swal: any;
  public obj: any = {
    dataManagementFee: {},
    salesCommissionFee: {},
    paymentTypeFee: {},
  };

  get items() {
    return this.$store.getters.GetDataFeeSetting;
  };
  get isFetching() {
    return this.$store.getters.GetFetchingFeeSetting;
  };

  @Watch('items')
  watchData() {
    if (this.items) {
      const itemData: any = cloneDeep(this.items);
      this.obj = {
        dataManagementFee: JSON.parse(get(itemData, 'global_fee_setting.dataManagementFee', '{}')),
        salesCommissionFee: JSON.parse(get(itemData, 'global_fee_setting.salesCommissionFee', '{}')),
        paymentTypeFee: JSON.parse(get(itemData, 'global_fee_setting.paymentTypeFee', '{}')),
      };
    }
  }

  mounted() {
    this.load();
  }

  load() {
    this.$store.dispatch('GetFeeSetting');
  }

  saveData() {
    this.$validator.validate().then(valid => {
      if (valid) {
        const payload = {
          dataManagementFee: JSON.stringify(this.obj.dataManagementFee),
          salesCommissionFee: JSON.stringify(this.obj.salesCommissionFee),
          paymentTypeFee: JSON.stringify(this.obj.paymentTypeFee),
        }
        this.$store
          .dispatch('UpdateFeeSetting', payload)
          .then(response => {
            const res = getResponseToMTH(
              response.data,
              this.$swal,
              'Fee Setting is updated'
            );
            if (res) {
              this.load();
            }
          })
          .catch(error => {
            this.$swal(
              constants.SOMETHING_WROING,
              error,
              constants.STATUS_ERROR
            );
          });
      }
    });
  }

  reset() {
    this.obj = {
      dataManagementFee: {},
      salesCommissionFee: {},
      paymentTypeFee: {},
    };
  }
};
